export enum EmailType {
    Work = 'email.work',
    Home = 'email.home',
}
